// removed by extract-text-webpack-plugin
module.exports = {"login-widget-wrapper":"LoginWidget__login-widget-wrapper","loginWidgetWrapper":"LoginWidget__login-widget-wrapper","login-widget-scenario":"LoginWidget__login-widget-scenario","loginWidgetScenario":"LoginWidget__login-widget-scenario"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/LoginWidget.scss
// module id = 1486
// module chunks = 8